import { LoaderFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import { AdminPanelUserDetailData } from "@/routes/adminPanel/users/edit/types/adminPanelUserDetailData.ts";
import { UserCoursesData } from "@/routes/adminPanel/users/courses/types/userCoursesData.ts";

export interface AdminPanelUserEditLoaderData {
    user: AdminPanelUserDetailData;
    courses: UserCoursesData;
}

const emptyCourses: UserCoursesData = {
    purchasedCourses: [],
    lecturerCourses: [],
};

export async function adminPanelUserEditLoader({
                                                   params,
                                               }: LoaderFunctionArgs): Promise<AdminPanelUserEditLoaderData> {
    try {
        if (!params.userId) {
            return { user: {} as AdminPanelUserDetailData, courses: emptyCourses };
        }

        // İki uç birbirinden bağımsız; paralel çekilir.
        const [detailResponse, coursesResponse] = await Promise.all([
            apiEndpoints.getUserDetailById(params.userId),
            apiEndpoints.getUserCourses(params.userId),
        ]);

        return {
            user: detailResponse.data,
            // Kurs listesi ekranın çalışması için zorunlu değil; gelmezse boş gösterilir.
            courses: coursesResponse.success ? coursesResponse.data : emptyCourses,
        };
    } catch (error) {
        throw new Error(error instanceof Error ? error.message : "Unknown error");
    }
}
